// Browser stand-in for node:crypto — just enough surface for boot.
// Hashing (mod checksums etc.) is fused off and returns dummy digests.
function makeHash() {
    return {
        update() {
            return this;
        },
        digest(encoding) {
            return encoding === undefined ? new Uint8Array(16) : "0".repeat(32);
        },
        copy: () => makeHash(),
    };
}

module.exports = {
    createHash: () => makeHash(),
    createHmac: () => makeHash(),
    randomBytes: (size) => {
        const buf = Buffer.alloc(size);
        if (globalThis.crypto !== undefined) {
            globalThis.crypto.getRandomValues(buf);
        } else {
            for (let i = 0; i < size; i++) {
                buf[i] = Math.floor(Math.random() * 256);
            }
        }
        return buf;
    },
    randomUUID: () =>
        globalThis.crypto?.randomUUID?.() ??
        "00000000-0000-4000-8000-000000000000",
    getRandomValues: (arr) => globalThis.crypto?.getRandomValues(arr) ?? arr,
};
